import Vue from 'vue';
import popOverSound from './assets/popover.wav';
import typingSound from './assets/typewriter.mp3';
import storyCompletedFile from './assets/story_completed.wav';
import progressStepFile from './assets/progress_step.mp3';

export const Progression = new Vue({
  data () {
    return {
      stepIndex: 1,
      storyIndex: 0,
      popOverSound: new Audio(popOverSound),
      typingSound: new Audio(typingSound),
      storyCompletedSound: new Audio(storyCompletedFile),
      progressStepSound: new Audio(progressStepFile)
    }
  }
});